import React from 'react';
import { Box } from '@mui/material';

type PreviewBoardPlaceholderProps = {
  boardWidth: number;
};

const PreviewBoardPlaceholder = ({ boardWidth }: PreviewBoardPlaceholderProps) => (
  <Box
    aria-hidden
    sx={{
      width: boardWidth,
      height: boardWidth,
      borderRadius: 0.5,
      bgcolor: 'action.hover',
      flexShrink: 0,
      pointerEvents: 'none',
    }}
  />
);

export default PreviewBoardPlaceholder;
